import styles from "./PoliciesList.module.css";
import * as policiesActions from "../../../store/actions/policies";
import { propertyTypes, liabilityTypes } from "../../../constants/data";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { COMMERCIAL, PERSONAL, formTypes } from "../../../constants/keys";

function PoliciesList({ policies }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const policyType = useSelector((state) => state.app.policyType);

  const handleRowClick = (policy) => {
    let selector;

    if (policy.PolicyType === "AUTO" && policyType.active === PERSONAL) {
      selector = formTypes.Auto;
    } else if (
      policy.PolicyType === "AUTO" &&
      policyType.active === COMMERCIAL
    ) {
      selector = formTypes.Vehicle;
    } else if (policy.PolicyType === "HOME") {
      selector = formTypes.Home;
    } else if (policy.PolicyType.trim() === "WC") {
      selector = formTypes.WorkersComp;
    } else if (
      propertyTypes.includes(policy.PolicyType.trim()) &&
      liabilityTypes.includes(policy.PolicyType.trim())
    ) {
      selector = formTypes.PropertyLiability;
    } else if (propertyTypes.includes(policy.PolicyType.trim())) {
      selector = formTypes.Property;
    } else if (liabilityTypes.includes(policy.PolicyType.trim())) {
      selector = formTypes.Liability;
    }

    const activePolicy = { ...policy, selector };
    dispatch(policiesActions.setActivePolicy(activePolicy)).then(
      history.push("/new-a")
    );
  };

  return (
    <div className={styles.container}>
      <Table striped borderless hover>
        <thead>
          <tr>
            <th>Policy Number</th>
            <th>Insured Name</th>
            <th>Policy Effective Date</th>
            <th>Policy Expiration Date</th>
            <th>Policy Type</th>
          </tr>
        </thead>
        <tbody>
          {policies.map((policy, index) => {
            return (
              <tr
                key={index}
                className={styles.row}
                onClick={() => {
                  handleRowClick(policy);
                }}
              >
                <td>
                  <button
                    className={styles.rowButton}
                    onClick={() => {
                      handleRowClick(policy);
                    }}
                  >
                    <strong>{policy.PolicyNumber}</strong>
                  </button>
                </td>
                <td>{policy.InsuredName.trim()}</td>
                <td>
                  {policy.PolicyEffectiveDate.substring(4, 6) +
                    "/" +
                    policy.PolicyEffectiveDate.substring(6, 8) +
                    "/" +
                    policy.PolicyEffectiveDate.substring(0, 4)}
                </td>
                <td>
                  {policy.PolicyExpirationDate.substring(4, 6) +
                    "/" +
                    policy.PolicyExpirationDate.substring(6, 8) +
                    "/" +
                    policy.PolicyExpirationDate.substring(0, 4)}
                </td>
                <td>{policy.PolicyType}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default PoliciesList;
